import React, {Component} from 'react';
import {scroller} from "react-scroll";
import {
	AJAX, hidePreloader, showPreloader
} from "../functions";
import RedirectOnlyHome from "../common/RedirectOnlyHome";
import {showPopupWithGoBack} from "../popups/PopupWithGoBack";
import ReactTooltip from "react-tooltip";

class HireIncludesPage extends Component {
	constructor(props) {
		super(props);
		this.onChangeInput = this.onChangeInput.bind(this);
		this.onSelect = this.onSelect.bind(this);
		this.onSwitch = this.onSwitch.bind(this);
		this.onSwitchLabour = this.onSwitchLabour.bind(this);
		this.setAdditionalDrivers = this.setAdditionalDrivers.bind(this);

		this.state = {
			additional_drivers_show: false,
			additional_drivers: (this.props.booking_form_data.booking.additional_drivers !== undefined) ? this.props.booking_form_data.booking.additional_drivers: 0,
			extra_kilometres_show: false,
			extra_kilometres: (this.props.booking_form_data.booking.extra_kilometres !== undefined) ? this.props.booking_form_data.booking.extra_kilometres: 0,

			premium_insurance: 0,
			roadside_assistance: this.props.booking_form_data.booking.roadside_assistance !== undefined ? this.props.booking_form_data.booking.roadside_assistance : 0,
			towing_surcharge: 0,

			additional_labour_show: false,
			pickup_labour_show: false,
			return_labour_show: false,

			pickup_labour_men: 0,
			pickup_labour_hours: 0,
			return_labour_men: 0,
			return_labour_hours: 0
		};
	}

	componentDidMount() {
		this.setData();
	}

	componentDidUpdate() {
		if (this.props.scroll_to_element === 'id_extras_page') {
			scroller.scrollTo(this.props.scroll_to_element, {
				duration: 800,
				smooth: true,
				containerId: "id_scrolling_div"
			})
			this.props.handleSetSomeBlock('scroll_to_element', '');
		}
	}

	handleCheckboxChange = (event) => {
		const { name, checked } = event.target;

		if ( name === 'additional_drivers_show') {
			if (checked) {
				this.setState({
					[name]: checked ? 1 : 0,
					additional_drivers : 1,
				});
			}
			else {
				this.setState({
					[name]: checked ? 1 : 0,
					additional_drivers : 0,
				});
			}
		}
		else {
			if ( name === 'extra_kilometres_show') {
				if (checked) {
					this.setState({
						[name]: checked ? 1 : 0,
						extra_kilometres : 10,
					});
				}
				else {
					this.setState({
						[name]: checked ? 1 : 0,
						extra_kilometres : 0,
					});
				}
			}
			else {
				this.setState({
					[name]: checked ? 1 : 0,
				});
			}
		}
	};

	setData() {
		if (this.props.booking_form_data.booking.premium_insurance !== undefined)
			this.setState({premium_insurance: this.props.booking_form_data.booking.premium_insurance});

		if (this.props.booking_form_data.booking.additional_drivers > 0)
			this.setState({additional_drivers_show: true, additional_drivers: this.props.booking_form_data.booking.additional_drivers});

		if (this.props.booking_form_data.booking.roadside_assistance !== undefined)
			this.setState({roadside_assistance: this.props.booking_form_data.booking.roadside_assistance});

		if (this.props.booking_form_data.booking.extra_kilometres > 0)
			this.setState({extra_kilometres_show: true, extra_kilometres: this.props.booking_form_data.booking.extra_kilometres});

		if (this.props.booking_form_data.booking.towing_surcharge !== undefined)
			this.setState({towing_surcharge: this.props.booking_form_data.booking.towing_surcharge});

		if (this.props.booking_form_data.booking.pickup_labour_men > 0 || this.props.booking_form_data.booking.return_labour_men > 0) {
			this.setState({additional_labour_show: true});

			if (this.props.booking_form_data.booking.pickup_labour_men > 0) {
				this.setState({pickup_labour_show: true, pickup_labour_men: this.props.booking_form_data.booking.pickup_labour_men, pickup_labour_hours: this.props.booking_form_data.booking.pickup_labour_hours});
			}
			if (this.props.booking_form_data.booking.return_labour_men > 0) {
				this.setState({return_labour_show: true, return_labour_men: this.props.booking_form_data.booking.return_labour_men, return_labour_hours: this.props.booking_form_data.booking.return_labour_hours});
			}
		}
	}

	onChangeInput(e) {
		let name = e.target.name;
		let value = e.target.value;
		this.setState({[name]: parseInt(value)});
	}

	onSwitch(block, action) {
		this.setState({[block]: action});

		if (block === 'additional_drivers_show' && !action)
			this.setState({additional_drivers : 0});

		if (block === 'extra_kilometres_show' && !action)
			this.setState({extra_kilometres : 0});

		if (block === 'additional_labour_show' && !action)
			this.setState({pickup_labour_men : 0, pickup_labour_hours: 0, return_labour_men: 0, return_labour_hours: 0, pickup_labour_show: false, return_labour_show: false});
	}

	onSwitchLabour(e, block) {
		let action = e.target.checked;
		this.setState({[block]: action});

		if (block === 'pickup_labour_show') {
			if (action)
				this.setState({pickup_labour_men: 1, pickup_labour_hours: 4}); //default values
			else
				this.setState({pickup_labour_men: 0, pickup_labour_hours: 0});
		}

		if (block === 'return_labour_show')
			if (action)
				this.setState({return_labour_men: 1, return_labour_hours: 4}); //default values
			else
				this.setState({return_labour_men: 0, return_labour_hours: 0});
	}

	setAdditionalDrivers(action) {
		let additional_drivers_show = this.state.additional_drivers_show;
		if (additional_drivers_show ){
			this.setState((prevState, prevProps) => {
				if (action && prevState.additional_drivers < 10){
					return {additional_drivers: ++prevState.additional_drivers};
				}
				else if (!action && prevState.additional_drivers > 0) {
					if ( prevState.additional_drivers === 1) {
						return {additional_drivers: 0, additional_drivers_show:false};
					}
					else
						return {additional_drivers: --prevState.additional_drivers};
				}
			});
		}
	}

	setExtraKilometres(action) {
		let extra_kilometres_show = this.state.extra_kilometres_show;
		if (extra_kilometres_show ) {
			this.setState((prevState, prevProps) => {
				if (action && prevState.extra_kilometres < 5000) {
					return {extra_kilometres: prevState.extra_kilometres + 5};
				} else if (!action && prevState.extra_kilometres > 0) {
					if ( prevState.extra_kilometres <= 5) {
						return { extra_kilometres: 0, extra_kilometres_show: false };
					}
					else
						return {extra_kilometres: prevState.extra_kilometres - 5};
				}
			});
		}
	}

	onSelect(e) {
		let booking_form_data = this.props.booking_form_data;
		let fields = this.props.booking_field_list.hire_includes;
		let params = {};
		let t = this;
		params.action = 'api/booking/get-total';
		params.vehicle_name = this.props.booking_form_data.vehicle_name;

		for (let item in fields) {
			if (this.state[fields[item]] !== undefined)
				booking_form_data.booking[fields[item]] = this.state[fields[item]];
		}

		Object.keys(booking_form_data.booking).map((k) => {
			params['booking['+k+']'] = booking_form_data.booking[k];
		});

		if (this.props.booking_form_data.booking.hire === 'local') {
			params['booking[pickup_location]'] = this.props.booking_form_data.booking.pickuplocationid;
			params['booking[return_location]'] = this.props.booking_form_data.booking.dropofflocationid;
		}
		this.props.handleSetBookingFormData(booking_form_data.booking, {}, {}, {});

		AJAX(bm_ajax_url, 'POST', params, {
			response_json: true,
			func_waiting: function () {
				showPreloader();
			},
			func_callback: function (resp) {
				t.props.handleSetBookingSummary(true, false, false, false, false, false, resp);
				t.props.handleSetSomeBlock('scroll_to_element', 'id_booking_summary_page');
				hidePreloader();
			},
			func_error: function (resp) {
				hidePreloader();
				showPopupWithGoBack(resp.message);
			}
		});
	}

	render() {
		return (<>
			<RedirectOnlyHome />
			<div id={'id_extras_page'} className={'extras'}>
				<div className="row block grey m-0 mb-5">
					<div className="col-md-12"><h2 className="fs-title text-center">Your hire includes…</h2>
						<div className="row mb-0 text-md-center">
							<div className="col-md d-flex flex-md-column flex-row align-items-center mb-3 mb-md-0">
								<div className="svg-truck svg-icon mb-md-3"></div>
								<div className="m-md-0 ml-3">
									One <b className="vehicle">{this.props.booking_form_data.vehicle_name}</b>&nbsp;from&nbsp;
									<b className="date_pickup">
										{
											(this.props.booking_form_data.booking.alternative_pickupdate !== '') ?
												this.props.booking_form_data.booking.alternative_pickupdate :
												this.props.booking_form_data.booking.pickup_date
										} {this.props.booking_form_data.booking.pickup_time}
									</b> to&nbsp;
									<b className="date_return">
										{
											(this.props.booking_form_data.booking.alternative_dropoffdate !== '') ?
												this.props.booking_form_data.booking.alternative_dropoffdate :
												this.props.booking_form_data.booking.return_date
										} {this.props.booking_form_data.booking.return_time}
									</b>
								</div>
							</div>
							<div className="col-md d-flex flex-md-column flex-row align-items-center mb-3 mb-md-0">
								<div className="svg-location svg-icon mb-md-3"></div>
								<div className="m-md-0 ml-3">
									{
										this.props.booking_form_data.booking.hire === "interstate" ?
											(<><b className="kms">{this.props.to_show.kms}</b> Kms for traveling between <b id="pickup">{this.props.to_show.pickup}</b> and <b id="return">{this.props.to_show.return}</b></>)
											:
											(<><b className="kms">{this.props.to_show.kms}</b> Kms are included per day</>)
									}
									<i className="tooltip-info" data-tip data-for="react_tooltip_4">&nbsp;</i>
									<ReactTooltip
										id="react_tooltip_4"
										place="top"
										effect="solid"
										multiline={true}
										className={'react_tooltip'}
										backgroundColor={'black'}
										scrollHide={true}
										isCapture={true}>
										Additional Kms can be pre-purchased at a reduced rate than charged at the end of the hire if you exceed the allocated amount.
									</ReactTooltip>
								</div>
							</div>
							<div className="col-md d-flex flex-md-column flex-row align-items-center mb-3 mb-md-0">
								<div className="svg-helm svg-icon mb-md-3"></div>
								<div className="m-md-0 ml-3">Only <b>1</b> authorized driver
									<i className="tooltip-info" data-tip data-for="react_tooltip_5">&nbsp;</i>
									<ReactTooltip
										id="react_tooltip_5"
										place="top"
										effect="solid"
										multiline={true}
										className={'react_tooltip'}
										backgroundColor={'black'}
										scrollHide={true}
										isCapture={true}>
										Only the one registered driver can drive this vehicle at any point during the hire. You can add additional drivers below if required.
									</ReactTooltip>
								</div>
							</div>
							<div className="col-md d-flex flex-md-column flex-row align-items-center mb-3 mb-md-0">
								<div className="svg-money-umbrella svg-icon mb-md-3"></div>
								<div className="m-md-0 ml-3">Basic Accident Cover (current excess liability is $7500)
									<i className="tooltip-info" data-tip data-for="react_tooltip_6">&nbsp;</i>
									<ReactTooltip
										id="react_tooltip_6"
										place="top"
										effect="solid"
										multiline={true}
										className={'react_tooltip'}
										backgroundColor={'black'}
										scrollHide={true}
										isCapture={true}>
										All vehicles come with standard insurance with Excess of $7500 in the event of an accident or claim.
									</ReactTooltip>
								</div>
							</div>
							<div className="col-md d-flex flex-md-column flex-row align-items-center mb-3 mb-md-0">
								<div className="svg-wheel svg-icon mb-md-3"></div>
								<div className="m-md-0 ml-3">Basic Roadside Assistance (excluding windscreen and tyre cover)
									<i className="tooltip-info" data-tip data-for="react_tooltip_7">&nbsp;</i>
									<ReactTooltip
										id="react_tooltip_7"
										place="top"
										effect="solid"
										multiline={true}
										className={'react_tooltip'}
										backgroundColor={'black'}
										scrollHide={true}
										isCapture={true}>
										We include FREE standard roadside assistance as protection against inherent mechanical faults in the Vehicle but fees and charges apply for any other faults or driver induced errors such as flat batteries, punctured tyres, lost keys etc. Get full peace of mind by purchasing Premium Roadside Assistance Protection now to cover you for any Roadside Assistance needs during your hire.
									</ReactTooltip>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="block row m-0 hire-includes">
					<div className="col-md-12">
						<h2 className="fs-title text-center">Additional Options</h2>
						<div className="row">
							<div className="col-md-6">
								<h3>Choose a Roadside Assistance protection</h3>
								<div className="row">
									<div className="col">
										<div  className="extra-item">
											<label>
												<input
													className={'custom-checkbox'}
													type="checkbox"
													checked={!this.state.roadside_assistance}
													value={0}
												/>
												<span>
													Basic
												</span>
											</label>
											<span className="price">Free</span>
										</div>

										<div className="extra-item-wrapper premium">
											<div className="extra-item-box">
												<label>
													<input
														type="checkbox"
														name="roadside_assistance"
														className={'custom-checkbox'}
														data-name="add_assistance"
														checked={this.state.roadside_assistance }
														onChange={this.handleCheckboxChange}
													/>
													<span>
														Premium
													</span>
												</label>
												<span>$<span className="price">{this.props.to_show.span_roadside_assistance}</span>/Day</span>
											</div>
											<hr />
											<ul className={'premium_roadside_assistance'}>
												<li>Personal Accident Coverage</li>
												<li>Theft Waiver</li>
												<li>Value Cover (Glass, lights, tyre protection)</li>
												<li>Collision Damage Waiver</li>
											</ul>
										</div>
									</div>
								</div>
							</div>
							<div className="col-md-6">
								<h3>Extras</h3>
								<div className="row">
									<div className="extra-item col-12">
										<label>
											<input
												className={'custom-checkbox'}
												type="checkbox"
												name="additional_drivers_show"
												checked={this.state.additional_drivers_show}
												onChange={this.handleCheckboxChange}
											/>
											<span>Additional driver</span>
										</label>
										<div className="extra-control">
											<div id="additional_drivers_field" className="counter" data-min="0" data-max="10"
												 data-step="1" data-name="additional_drivers">
												<button className="btn btn-green-border decrementer"
														onClick={() => this.setAdditionalDrivers(false)}>-
												</button>
												<input className="number-input" name="additional_drivers" min="0" max="10" step="1" value={this.state.additional_drivers} readOnly={!this.state.additional_drivers_show}/>
												<button className="btn btn-green-border incrementer"
														onClick={() => this.setAdditionalDrivers(true)}>+
												</button>
											</div>
										</div>
										<span>$<span className="price">10</span>/Day</span>
									</div>
									<div className="extra-item col-12">
										<label>
											<input
												name={'extra_kilometres_show'}
												onChange={this.handleCheckboxChange}
												checked={this.state.extra_kilometres_show}
												className={'custom-checkbox'}
												type="checkbox"
											/>
											<span>Pre-purchase KM's</span>
										</label>
										<div className="extra-control add_more_km">
											<div id="extra_kilometres_field" className="counter" data-min="0" data-max="5000"
												 data-step="5" data-name="extra_kilometres">
												<button className="btn btn-green-border decrementer"
														onClick={() => this.setExtraKilometres(false)}>-
												</button>
												<input className="number-input" name="extra_kilometres" min="0" max="5000" step="5" readOnly={!this.state.extra_kilometres_show}  value={this.state.extra_kilometres}/>
												<button className="btn btn-green-border incrementer"
														onClick={() => this.setExtraKilometres(true)}>+
												</button>
											</div>
										</div>
										<span>$<span className="price">0.25</span>/km</span>
									</div>
									<div className="extra-item col-12">
										<label>
											<input
												className={'custom-checkbox'}
												type="checkbox"
												name={'premium_insurance'}
												checked={this.state.premium_insurance}
												onChange={this.handleCheckboxChange}
											/>
											<span>Reduce excess to $1000</span>
										</label>
										<div className="extra-control"></div>
										<span>$<span class="price">{this.props.to_show.insurance_cover}</span>/Day</span>
									</div>
								</div>
							</div>
						</div>
					</div>
					<input id="step-2" type="button" className="btn  btn-green m-auto" value="Continue" onClick={this.onSelect}/>
				</div>
			</div>
		</>);
	}
}

export default HireIncludesPage;